import axios, { AxiosResponse } from 'axios';
import { Evento } from './suite.interfaces';
import { CommonService } from './common.services';

export class EventoService extends CommonService {

  async validarEvento(evento:number): Promise<Evento> {
    try {
      const response: AxiosResponse<Evento> = await axios.get(this.getServerUrl() + '/mobile/validarEvento?evento=' + evento, { headers: {"Authorization": this.token, "Client-ID" : this.clientId }});
      return response.data as Evento;
    } catch (error) {
      throw this.manageError(error);    
    }
  }
}

